// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"9c19f583","171":"648b62af","453":"811f5158"}[chunkId] + ".chunk.js";
};